var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-steps"},[_c('ul',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('li',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(step.date),expression:"step.date",modifiers:{"hover":true,"top":true}}],key:index,class:[
        step.current ? 'is-active' : '',
        step.name === 'cancelled' ? 'cancelled' : '',
        step.name === 'cancelled' && step.current ? 'is-cancelled' : '',
        step.name === 'cancelled' && !step.current ? 'hide-cancelled' : '',
      ],attrs:{"title":""}},[_vm._v(" "+_vm._s(_vm.$t("myLoads.myLoadsDetail." + step.name + ""))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }